<div
  ngbDropdown
  dropdownClass="cf-dropdown"
  container="body"
  [placement]="placement()"
  (click)="$event.stopPropagation()"
>
  <div
    ngbDropdownToggle
    class="pointer d-flex align-items-center"
    (click)="toggleMenu(); $event.preventDefault(); $event.stopPropagation()"
  >
    <ng-content select="[cf-dropdown-toggle]"></ng-content>
    <svg
      *ngIf="showArrow()"
      cfIcon="chevron_down"
      size="sm"
      class="tw:ml-1 tw:text-black"
      [class.show-menu]="showMenu"
    ></svg>
  </div>

  <div ngbDropdownMenu (clickOutside)="closeMenu()" (click)="closeMenu(); $event.stopPropagation()">
    <ng-content select="[cf-dropdown-filter]"></ng-content>
    <ng-content select="[cf-dropdown-items]"></ng-content>

    <ng-content select="cf-dropdown-item"></ng-content>
  </div>
</div>
